import React from "react";
import FpsImage1 from "../assets/new/fps-image-1.png";
import FpsImage2 from "../assets/new/fps-image-2.png";
import FpsImage3 from "../assets/new/fps-image-3.png";
import { GAME_CONFIG } from "../config";

const FPSAsset = ({ image, className }) => {
  return (
    <div className={`fps-image ${className}`}>
      <img src={image} alt="" />
    </div>
  );
};

let fpsImages = GAME_CONFIG.hasPrepStage
  ? {
      1: <FPSAsset image={FpsImage1} className="fps-image-1" />,
      2: <FPSAsset image={FpsImage2} className="fps-image-2" />,
      3: <FPSAsset image={FpsImage3} className="fps-image-3" />,
    }
  : {
      0: <FPSAsset image={FpsImage1} className="fps-image-1" />,
      1: <FPSAsset image={FpsImage2} className="fps-image-2" />,
      2: <FPSAsset image={FpsImage3} className="fps-image-3" />,
    };

export default function FPSImage({ currentStage }) {
  return <div>{fpsImages[currentStage]}</div>;
}
